import type { VFC } from 'react';
import { Button, Col, Row } from 'antd';
import { useParams } from 'react-router-dom';
import { PageHeader, ContentSwitch, FallbackContent } from 'components';
import { RowGutter } from 'common/spacing';
import { type BaseGlobalModalProps, useGlobalModalContext } from 'components/modal/GlobalModal';
import { Overview } from './routes/overview/Content';
import { TrialCredits } from './routes/trial-credits/Content';
import { RESELLERS_TABS_TRANSLATED, ResellersTab } from './enums/resellersTab';
import { ResellersTabs } from './components/Tabs';
import { Credits } from './routes/credits/Content';
import { ResellerCreditsModal } from './routes/credits/components/Modal';
import { Icon } from '@/components/icon';

export const Resellers: VFC = () => {
  const { resellersTab } = useParams<{
    resellersTab: ResellersTab;
  }>();

  const { showModal, hideModal } = useGlobalModalContext();

  const handleAddCreditInvoice = () => {
    showModal<BaseGlobalModalProps & { onHide: () => void }>(ResellerCreditsModal, { onHide: hideModal });
  };

  return (
    <Row gutter={[0, RowGutter.Default]}>
      <Col span={24}>
        <PageHeader
          breadcrumbs={[
            { path: `/resellers/${ResellersTab.Overview}`, breadcrumbName: 'Resellers' },
            { path: '', breadcrumbName: RESELLERS_TABS_TRANSLATED[resellersTab] },
          ]}
          extra={
            resellersTab === ResellersTab.Credits && (
              <Button icon={<Icon iconString="plus" />} type="primary" onClick={handleAddCreditInvoice}>
                Add credit invoice
              </Button>
            )
          }
          footer={<ResellersTabs />}
          ghost={false}
          title="Resellers"
        />
      </Col>
      <Col span={24}>
        <ContentSwitch
          activeId={resellersTab}
          notFoundContent={<FallbackContent emptyProps={{ description: 'Page does not exist' }} />}
        >
          <Overview id={ResellersTab.Overview} />
          <TrialCredits id={ResellersTab.TrialCredits} />
          <Credits id={ResellersTab.Credits} />
        </ContentSwitch>
      </Col>
    </Row>
  );
};
